// json data schemas
import { primeProtocolDataSchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/dataSchemas/protocol/primeProtocolDataSchema"
import { primeResultsDataSchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/dataSchemas/results/primeResultsDataSchema"
import { delayedResultsDataSchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/dataSchemas/delayedResults/delayedResultsDataSchema"
import { sponsorTrialDataSchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/dataSchemas/sponsorTrialWebsite/sponsorTrialWebsiteDataSchema"

// ui schemas
import { primeProtocolUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/protocol/primeProtocolUISchema"
import { ctgProtocolUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/protocol/ctgProtocolUISchema"
import { eupasProtocolUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/protocol/eupasProtocolUISchema"
import { ctisProtocolUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/protocol/ctisProtocolUISchema"
import { jrctProtocolUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/protocol/jrctProtocolUISchema"

import { secondaryAttributesUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/protocol/secondaryAttributesUISchema"
import { primeResultsUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/results/primeResultsUISchema"
import { ctgResultsUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/results/ctgResultsUISchema"
import { eudraResultsUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/results/eudraResultsUISchema"
import { jrctResultsUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/results/jrctResultsUISchema"
import { delayedResultsUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/delayedResults/delayedResultsUISchema"
import { sponsorTrialUISchema } from "../containers/studies/Study/subcomponents/Authoring/RJS/schemas/uiSchemas/sponsorTrialWebsite/sponsorTrialWebsiteUISchema"

const formSchemas = {
  protocol: {
    title: "Protocol",
    properties: {
      global: {
        title: "Global",
        schema: primeProtocolDataSchema,
        uiSchema: primeProtocolUISchema,
      },
      ctg: {
        title: "CTG",
        schema: primeProtocolDataSchema,
        uiSchema: ctgProtocolUISchema,
      },
      eupas: {
        title: "EMA RWD",
        schema: primeProtocolDataSchema,
        uiSchema: eupasProtocolUISchema,
      },
      ctis: {
        title: "CTIS",
        schema: primeProtocolDataSchema,
        uiSchema: ctisProtocolUISchema,
      },
      jrct: {
        title: "JRCT",
        schema: primeProtocolDataSchema,
        uiSchema: jrctProtocolUISchema,
      },
    },
  },
  results: {
    title: "Results",
    properties: {
      global: {
        title: "Global",
        schema: primeResultsDataSchema,
        uiSchema: primeResultsUISchema,
      },
      ctg: {
        title: "CTG",
        schema: primeResultsDataSchema,
        uiSchema: ctgResultsUISchema,
      },
      eudra: {
        title: "EudraCT",
        submitToCTG: "eudract",
        schema: primeResultsDataSchema,
        uiSchema: eudraResultsUISchema,
      },
      jrct: {
        title: "JRCT",
        schema: primeResultsDataSchema,
        uiSchema: jrctResultsUISchema,
      },
    },
  },
  secondaryAttributes: {
    title: "Study Details",
    properties: {
      global: {
        title: "Global",
        schema: primeProtocolDataSchema,
        uiSchema: secondaryAttributesUISchema,
      },
    },
  },
  delayedResultsCertification: {
    title: "Delayed Results Certification",
    submitToCTG: "delayed_results_certification",
    properties: {
      global: {
        title: "Global",
        schema: delayedResultsDataSchema,
        uiSchema: delayedResultsUISchema,
      },
      ctg: {
        title: "CTG",
        schema: delayedResultsDataSchema,
        uiSchema: delayedResultsUISchema,
      },
    },
  },
  sponsorTrialWebsite: {
    title: "Sponsor Trial Website",
    properties: {
      global: {
        title: "Global",
        schema: sponsorTrialDataSchema,
        uiSchema: sponsorTrialUISchema,
      },
    },
  },
}

const previewFormSchemas = {
  protocol: {
    title: "Protocol",
    properties: {
      ctg: {
        title: "CTG",
        schema: primeProtocolDataSchema,
        uiSchema: ctgProtocolUISchema,
      },
      eupas: {
        title: "EMA RWD",
        schema: primeProtocolDataSchema,
        uiSchema: eupasProtocolUISchema,
      },
      ctis: {
        title: "CTIS",
        schema: primeProtocolDataSchema,
        uiSchema: ctisProtocolUISchema,
      },
      jrct: {
        title: "JRCT",
        schema: primeProtocolDataSchema,
        uiSchema: jrctProtocolUISchema,
      },
    },
  },
  results: {
    title: "Results",
    properties: {
      ctg: {
        title: "CTG",
        schema: primeResultsDataSchema,
        uiSchema: ctgResultsUISchema,
      },
      eudra: {
        title: "EudraCT",
        submitToCTG: "eudract",
        schema: primeResultsDataSchema,
        uiSchema: eudraResultsUISchema,
      },
      jrct: {
        title: "JRCT",
        schema: primeResultsDataSchema,
        uiSchema: jrctResultsUISchema,
      },
    },
  },
}

// query string params sent in reviewer view
const reviewerUrlParams = {
  projId: "proj-id",
  taskId: "task-id",
  // "ctg", "eudract"
  docs: "docs",
  formView: "form-view",
  // "results", "protocol", "secondaryAttributes","delayedResultsCertification"
  formSection: "form-section",
  viewType: "view-type",
  // 1.0, 5.1, "None"
  formVersion: "form-version",
}

// params on the reviewer/approver page and how they map to formSchemas

const sectionUrlParamMap = {
  "study+details": "secondaryAttributes",
  "delayed+results+certification": "delayedResultsCertification",
  "sponsor+trial+website": "sponsorTrialWebsite",
}

const sectionTitleKeyMap = {
  Results: "results",
  Protocol: "protocol",
  "Study Details": "secondaryAttributes",
  "Delayed Results Certification": "delayedResultsCertification",
  "Sponsor Trial Website": "sponsorTrialWebsite",
}

const viewTitleKeyMap = {
  Global: "global",
  CTG: "ctg",
  EUPAS: "eupas",
  "EMA RWD": "eupas",
  CTIS: "ctis",
  EudraCT: "eudra",
  EUDRACT: "eudra",
  JRCT: "jrct",
}

const registryUrlParamMap = {
  eudract: "eudra",
}

const formNavItems = {
  protocol: {
    order: {
      ctg: [
        "root_protocol_study_identification-container",
        "root_protocol_contact_information-container",
        "root_protocol_study_oversight-container",
        "root_protocol_study_timeline-container",
        "root_protocol_study_description-container",
        "root_protocol_study_scope-container",
        "root_protocol_study_arms-container",
        "root_protocol_study_eligibilty-container",
        "root_protocol_study_ipd-container",
        "root_protocol_study_outcome_measures-container",
        "root_protocol_study_reference-container",
        "locations-container",
      ],
      jrct: [
        "root_protocol_study_identification-container",
        "root_protocol_investigator_information-container",
        "root_protocol_non_investigator_information-container",
        "root_protocol_information_on_multicenter_clinical_trials-container",
        "root_protocol_milestone_dates-field-container",
        "root_protocol_overview_of_pharmaceuticals-container",
        "root_protocol_study_timeline-container",
        "root_protocol_monetary_sponsor-container",
        "root_protocol_irb_information-container",
        "root_protocol_study_ipd-container",
      ],
      ctis: [
        "root_protocol_study_identification-container",
        "root_protocol_secondary_attributes-field-container",
        "root_protocol_ctis_form-container",
        "root_protocol_mscs-container",
        "root_protocol_study_description-container",
        "root_protocol_study_eligibilty-container",
        "root_protocol_study_reference-container",
        "root_protocol_study_scope-container",
        "root_protocol_study_ipd-container",
        "root_protocol_study_outcome_measures-container",
        "locations-container",
      ],
      eupas: [
        "root_protocol_study_identification-container",
        "root_protocol_contact_information-container",
        "root_protocol_milestone_dates-field-container",
        "root_protocol_study_description-container",
        "root_protocol_study_scope-container",
        "root_protocol_study_arms-container",
        "root_protocol_study_eligibilty-container",
        "root_protocol_study_outcome_measures-container",
        "root_protocol_study_reference-container",
        "root_protocol_ema_hma_additional_information-container",
      ],
    },
    properties: {
      "root_protocol_study_identification-container": {
        registries: {
          global: "Study Identification and Information",
          ctg: "Study Identification and Information",
          eupas: "Study Identification and Information",
          ctis: "Study Identification and Information",
          jrct: "Research Information",
        },
      },
      "root_protocol_contact_information-container": {
        registries: {
          global: "Study Sponsor, Collaborators and Contact Information",
          ctg: "Study Sponsor, Collaborators and Contact Information",
          eupas: "Study Sponsor, Collaborators and Contact Information",
        },
      },
      "root_protocol_investigator_information-container": {
        registries: {
          global: "Principal Investigator Information",
          jrct: "Principal Investigator Information",
        },
      },
      "root_protocol_non_investigator_information-container": {
        registries: {
          global: "Other Contributors Information",
          jrct: "Other Contributors Information",
        },
      },
      "root_protocol_study_timeline-container": {
        registries: {
          global: "Study Timelines and Status",
          ctg: "Study Timelines and Status",
          jrct: "Study Status and Compensation Information",
        },
      },
      "root_protocol_secondary_attributes-field-container": {
        registries: {
          ctis: "Study Timelines and Status",
        },
      },
      "root_protocol_monetary_sponsor-container": {
        registries: {
          global: "Monetary Sponsor",
          jrct: "Monetary Sponsor",
        },
      },
      "root_protocol_study_oversight-container": {
        registries: {
          global: "Oversight",
          ctg: "Oversight",
        },
      },
      "root_protocol_information_on_multicenter_clinical_trials-container": {
        registries: {
          global: "Multicenter Clinical Trials Information",
          jrct: "Multicenter Clinical Trials Information",
        },
      },
      "root_protocol_overview_of_pharmaceuticals-container": {
        registries: {
          global: "Summary of Investigational Products",
          jrct: "Summary of Investigational Products",
        },
      },
      "root_protocol_ctis_form-container": {
        registries: {
          global: "Form",
          ctis: "Form",
        },
      },
      "root_protocol_mscs-container": {
        registries: {
          global: "MSCs",
          ctis: "MSCs",
        },
      },
      "root_protocol_study_description-container": {
        registries: {
          global: "Study Description and Conditions",
          ctg: "Study Description and Conditions",
          eupas: "Study Description and Conditions",
          ctis: "Trial Information",
        },
      },
      "root_protocol_study_scope-container": {
        registries: {
          global: "Study Scope and Design",
          ctg: "Study Scope and Design",
          eupas: "Study Scope and Design",
          ctis: "Countries outside the European Economic Area",
        },
      },
      "root_protocol_study_arms-container": {
        registries: {
          global: "Arms and Interventions",
          ctg: "Arms and Interventions",
          eupas: "Study Drug or IMP Information",
        },
      },
      "root_protocol_study_eligibilty-container": {
        registries: {
          global: "Eligibility",
          ctg: "Eligibility",
          eupas: "Eligibility",
          ctis: "Eligibility",
        },
      },
      "root_protocol_study_ipd-container": {
        registries: {
          global: "IPD Sharing Statements",
          ctg: "IPD Sharing Statements",
          ctis: "IPD Sharing Statements",
          jrct: "Other Information",
        },
      },
      "root_protocol_study_outcome_measures-container": {
        registries: {
          global: "Study Endpoints/Outcome Measures",
          ctg: "Study Endpoints/Outcome Measures",
          eupas: "Study Endpoints/Outcome Measures",
          ctis: "Study Endpoints/Outcome Measures",
        },
      },
      "root_protocol_study_reference-container": {
        registries: {
          global: "Citations, References and URLs",
          ctg: "Citations, References and URLs",
          eupas: "Citations, References and URLs",
          ctis: "References",
        },
      },
      "root_protocol_irb_information-container": {
        registries: {
          global: "IRB Information",
          jrct: "IRB Information",
        },
      },
      "root_protocol_ema_hma_additional_information-container": {
        registries: {
          global: "EMA HMA Catalogue Additional Information",
          eupas: "EMA HMA Catalogue Additional Information",
        },
      },
      "locations-container": {
        registries: {
          global: "Locations",
          ctg: "Locations",
        },
      },
      "root_protocol_milestone_dates-field-container": {
        registries: {
          eupas: "Study Timelines and Status",
          jrct: "Study Objective and Summary",
        },
      },
    },
  },
  results: {
    order: {
      eudra: [
        "root_results_trial_info-container",
        "root_results_participant_flow-container",
        "root_results_baseline_characteristics-container",
        "root_results_outcome_measures-container",
        "root_results_adverse_events-container",
        "root_results_more_info-container",
      ],
    },
    properties: {
      "root_results_participant_flow-container": {
        registries: {
          global: "Participant Flow",
          ctg: "Participant Flow",
          eudra: "Subject Disposition",
        },
      },
      "root_results_baseline_characteristics-container": {
        registries: {
          global: "Baseline Characteristics",
          ctg: "Baseline Characteristics",
          eudra: "Baseline Characteristics",
        },
      },
      "root_results_outcome_measures-container": {
        registries: {
          global: "Outcome Measures",
          ctg: "Outcome Measures",
          eudra: "End Points",
        },
      },
      "root_results_adverse_events-container": {
        registries: {
          global: "Adverse Events",
          ctg: "Adverse Events",
          eudra: "Adverse Events",
        },
      },
      "root_results_more_info-container": {
        registries: {
          global: "More Information",
          ctg: "More Information",
          eudra: "More Information",
        },
      },
      "root_results_trial_info-container": {
        registries: {
          global: "Trial Information",
          eudra: "Trial Information",
        },
      },
      "root_results_research_information-container": {
        registries: {
          global: "Research Information",
          jrct: "Research Information",
        },
      },
    },
  },
  secondaryAttributes: {
    order: {},
    properties: {
      "root_protocol_study_eligibilty-container": {
        registries: {
          global: "Study Details",
        },
      },
      "root_protocol_general-container": {
        registries: {
          global: "General",
        },
      },
      "root_protocol_milestone_dates-field-container": {
        registries: {
          global: "Milestone Dates",
        },
      },
      "root_protocol_secondary_attributes-field-container": {
        registries: {
          global: "Secondary Attributes",
        },
      },
      "root_protocol_secondary_attributes_internal-field-container": {
        registries: {
          global: "Internal",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_usa-field-container": {
        registries: {
          global: "USA",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_europe-field-container": {
        registries: {
          global: "Europe",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_germany-field-container": {
        registries: {
          global: "Germany",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_spain-field-container": {
        registries: {
          global: "Spain",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_netherlands-field-container": {
        registries: {
          global: "Netherlands",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_mexico-field-container": {
        registries: {
          global: "Mexico",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_japan-field-container": {
        registries: {
          global: "Japan",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_south_korea-field-container": {
        registries: {
          global: "South Korea",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_united_kingdom-field-container": {
        registries: {
          global: "United Kingdom",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_australia_and_newzealand-field-container": {
        registries: {
          global: "Australia and New Zealand",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_south_africa-field-container": {
        registries: {
          global: "South Africa",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_switzerland-field-container": {
        registries: {
          global: "Switzerland",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_secondary_attributes_china-field-container": {
        registries: {
          global: "China",
        },
        style: {
          indent: true,
        },
      },
      "root_protocol_protocol_amendments-field-container": {
        registries: {
          global: "Protocol Amendments",
        },
      },
    },
  },
}

export const FORM_TYPES = {
  "Global Protocol": {
    value: {
      form_section: "Protocol",
      form_view: "Global",
    },
    label: "Global Protocol",
  },
  "Global Results": {
    value: {
      form_section: "Results",
      form_view: "Global",
    },
    label: "Global Results",
  },
  "Global Study Details": {
    value: {
      form_section: "Study Details",
      form_view: "Global",
    },
    label: "Global Study Details",
  },
  "Global Delayed Results Certification": {
    value: {
      form_section: "Delayed Results Certification",
      form_view: "Global",
    },
    label: "Global Delayed Results Certification",
  },
  "Global Sponsor Trial Website": {
    value: {
      form_section: "Sponsor Trial Website",
      form_view: "Global",
    },
    label: "Global Sponsor Trial Website",
  },
  "CTG Protocol": {
    value: {
      form_section: "Protocol",
      form_view: "CTG",
    },
    label: "CTG Protocol",
  },
  "CTG Results": {
    value: {
      form_section: "Results",
      form_view: "CTG",
    },
    label: "CTG Results",
  },
  "CTG Delayed Results Certification": {
    value: {
      form_section: "Delayed Results Certification",
      form_view: "CTG",
    },
    label: "CTG Delayed Results Certification",
  },
  "EMA RWD Protocol": {
    value: {
      form_section: "Protocol",
      form_view: "EMA RWD",
    },
    label: "EMA RWD Protocol",
  },
  "CTIS Protocol": {
    value: {
      form_section: "Protocol",
      form_view: "CTIS",
    },
    label: "CTIS Protocol",
  },
  "JRCT Protocol": {
    value: {
      form_section: "Protocol",
      form_view: "JRCT",
    },
    label: "JRCT Protocol",
  },
  "JRCT Results": {
    value: {
      form_section: "Results",
      form_view: "JRCT",
    },
    label: "JRCT Results",
  },
  "EUDRACT Results": {
    value: {
      form_section: "Results",
      form_view: "EUDRACT",
    },
    label: "EUDRACT Results",
  },
}

const registriesLangTranslationMap = {
  jrct: "jp",
}

const registriesWithTranslations = ["jrct"]

const stringTranslationFieldSet = new Set(["date"])

const SCROLLABLE_AUTHORING_CONTAINER = {
  REVIEW_ID: "authoring-form-container",
  FORM_CLASSNAME: "right-section",
}

const FORM_VIEW_STATE = "auth-form-view-state"

const REGISTRY_PREVIEW_TYPE = {
  ctisResults: "ctisResults",
}

const EMA_RWD_OPTIONS = {
  medicine: "ema-rwd-medicine",
  substance_inn: "ema-rwd-substance_inn",
  condition: "ema-rwd-condition",
  atc_code: "ema-rwd-atc_code",
  institution: "ema-rwd-institution",
  data_source: "ema-rwd-data_source",
  network: "ema-rwd-network",
}

const EMA_RWD_OPTIONS_TYPE_MAP = {
  "root.protocol.contact_information.additional_institutions": "institution",
  "root.protocol.contact_information.institution_conducting_study": "institution",
  "root.protocol.contact_information.networks_registered_encepp": "network",
  "root.protocol.study_arms.atc_code": "atc_code",
  "root.protocol.study_arms.medicine_name": "medicine",
  "root.protocol.study_arms.substance_inns": "substance_inn",
  "root.protocol.ema_hma_additional_information.registered_data_sources": "data_source",
}

export {
  formSchemas,
  previewFormSchemas,
  reviewerUrlParams,
  sectionUrlParamMap,
  registryUrlParamMap,
  formNavItems,
  sectionTitleKeyMap,
  viewTitleKeyMap,
  SCROLLABLE_AUTHORING_CONTAINER,
  registriesLangTranslationMap,
  registriesWithTranslations,
  stringTranslationFieldSet,
  REGISTRY_PREVIEW_TYPE,
  FORM_VIEW_STATE,
  EMA_RWD_OPTIONS,
  EMA_RWD_OPTIONS_TYPE_MAP,
}
